import { format } from "date-fns"
<template>
  <content-box class="htmldiff" :width="'640px'">
    <i class="close icon icon--close-size16" @click="$emit('onClose')"></i>
    <h4 v-html="$t('common.htmldiff.title')"></h4>
    <p v-html="$t('common.htmldiff.desc', { count: htmlDiffList.length, plural: 's' })"></p>
    <ul>
      <li v-for="htmldiff in htmlDiffList" :key="htmldiff.today">
        <i class="icon icon--link-site-size20" @click="onDateSelected(htmldiff.today)"></i>
        <span class="date"
              v-html="Format(htmldiff.today, 'YYYY.M.D')"></span>
        <span class="diff"
              v-html="$t('common.htmldiff.compare', { ratio: Math.round(htmldiff.ratio * 100) })"></span>
      </li>
    </ul>
  </content-box>
</template>

<script>
import { format } from 'date-fns'
import ContentBox from '../ui/ContentBox'
export default {
  components: {
    ContentBox
  },
  props: [
    'htmlDiffList'
  ],
  data () {
    return {}
  },
  methods: {
    Format (date, formatText) {
      return format(date, formatText)
    },
    onDateSelected (date) {
      date = format(date, 'YYYY-MM-DD')
      let url = [location.protocol, '//', location.host, location.pathname].join('')
      url += `?startDate=${date}&endDate=${date}`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.htmldiff {
  position: relative;
  padding: 30px;

  .close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
  }

  h4 {
    color: #2f2f2f;
    font-weight: bold;
    font-size: 15px;
  }

  p {
    color: #ec0047;
    font-size: 12px;
    margin: 13px 0 17px 0;
  }

  ul {
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    height: 362px;
    overflow-y: auto;
    padding: 5px 0;

    li {
      color: #2f2f2f;
      font-size: 12px;
      margin: 10px;

      span {
        display: inline-block;
        padding: 4px 0;
        height: 12px;
      }

      .icon {
        vertical-align: middle;
        float: left;
        cursor: pointer;
      }

      .date {
        float: left;
        width: 80px;
        margin-left: 17px;
      }
    }
  }
}
</style>
